import { Link } from "@tanstack/react-router";

import { Marquee } from "../../../components/marquee";
import { marqueeImages } from "../../../data/marquee";

export function WhyLoseWeight() {
  return (
    <div className="pb-[80px] sm:pb-[60px] lg:pb-[80px]">
      <div className="relative z-[2] flex flex-col items-center text-center">
        <h2 className="mb-[2%] text-[32px] font-bold leading-[1.2] font-inter text-[#15306A] sm:text-[56px] sm:leading-[60px]">
          Why choose ProxyMedicine
        </h2>
        <p className="lg:w-4/10 my-6 mb-[2.5%] w-10/12 text-base text-[#7F8493] sm:text-lg">
        We combine medical expertise with proven weight loss strategies to help you achieve lasting results.
        </p>
        <Link
          to="/welcome"
          className="mt-6 inline-block rounded-lg bg-[#4272DD] px-6 py-3 text-center text-base font-semibold text-white sm:py-4 sm:text-lg"
        >
          GET STARTED
        </Link>

        {/* Mobile layout for benefit cards */}
        <div className="mt-8 flex w-[90%] space-y-3 flex-col gap-4 sm:hidden">
          <div className="border-l-solid h-[41px] w-[280px] rotate-[3.62deg] rounded-r-xl border-[1px] border-l-4 border-[#ECECED] border-l-[#4272DD] bg-white px-4 py-3 text-xs font-medium leading-[16.8px] text-[#363840] shadow-[0px_2px_4px_0px_#0000000D]">
            <p>Feel amazing in everything you wear.</p>
          </div>
          <div className="border-r-solid h-[41px] w-[280px] -rotate-[3.62deg] self-end rounded-l-xl border-[1px] border-r-4 border-[#ECECED] border-r-[#4272DD] bg-white px-4 py-3 text-xs font-medium leading-[16.8px] text-[#363840] shadow-[0px_2px_4px_0px_#0000000D]">
            <p>Look good on your summer vacation.</p>
          </div>
          <div className="border-l-solid h-[41px] w-[280px] rotate-[3.62deg] rounded-r-xl border-[1px] border-l-4 border-[#ECECED] border-l-[#4272DD] bg-white px-4 py-3 text-xs font-medium leading-[16.8px] text-[#363840] shadow-[0px_2px_4px_0px_#0000000D]">
            <p>Enjoy restful sleep.</p>
          </div>
          <div className="border-r-solid h-[41px] w-[280px] -rotate-[3.62deg] self-end rounded-l-xl border-[1px] border-r-4 border-[#ECECED] border-r-[#4272DD] bg-white px-4 py-3 text-xs font-medium leading-[16.8px] text-[#363840] shadow-[0px_2px_4px_0px_#0000000D]">
            <p>Reduce stress.</p>
          </div>
        </div>

        {/* Desktop layout for benefit cards */}
        <div className="hidden w-full sm:block">
          <div className="border-l-solid absolute z-10 bottom-0 left-[calc(1/15_*_100%)] rounded-br-xl rounded-tr-xl border-[1px] border-l-4 border-solid border-[#ECECED] border-l-[#4272DD] bg-white px-6 py-4 text-lg font-medium text-[#363840] shadow-[0px_2px_4px_0px_#0000000D,2px_6px_7px_0px_#0000000A,4px_14px_9px_0px_#00000008,6px_26px_11px_0px_#00000003,10px_40px_12px_0px_#00000000]">
            <p>Feel amazing in everything you wear.</p>
          </div>
          <div className="border-r-solid absolute z-10 bottom-0 right-[calc(1/15_*_100%)] rounded-bl-xl rounded-tl-xl border-[1px] border-r-4 border-solid border-[#ECECED] border-r-[#4272DD] bg-white px-6 py-4 text-lg font-medium text-[#363840] shadow-[0px_2px_4px_0px_#0000000D,2px_6px_7px_0px_#0000000A,4px_14px_9px_0px_#00000008,6px_26px_11px_0px_#00000003,10px_40px_12px_0px_#00000000]">
            <p>Look good on your summer vacation.</p>
          </div>
          <div className="border-l-solid absolute -bottom-[25%] left-[calc(1/11_*_100%)] rotate-[2.62deg] rounded-br-xl rounded-tr-xl border-[1px] border-l-4 border-solid border-[#ECECED] border-l-[#4272DD] bg-white px-6 py-4 text-lg font-medium text-[#363840] shadow-[0px_2px_4px_0px_#0000000D,2px_6px_7px_0px_#0000000A,4px_14px_9px_0px_#00000008,6px_26px_11px_0px_#00000003,10px_40px_12px_0px_#00000000]">
            <p>Enjoy restful sleep.</p>
          </div>
          <div className="border-r-solid absolute -bottom-[25%] right-[calc(1/11_*_100%)] -rotate-[2.62deg] rounded-bl-xl rounded-tl-xl border-[1px] border-r-4 border-solid border-[#ECECED] border-r-[#4272DD] bg-white px-6 py-4 text-lg font-medium text-[#363840] shadow-[0px_2px_4px_0px_#0000000D,2px_6px_7px_0px_#0000000A,4px_14px_9px_0px_#00000008,6px_26px_11px_0px_#00000003,10px_40px_12px_0px_#00000000]">
            <p>Reduce stress.</p>
          </div>
        </div>
      </div>
      <div>
        <Marquee
          images={marqueeImages}
          className="my-[80px] h-[232px] sm:my-[120px] sm:h-[200px] lg:z-[1] lg:h-[200px]"
        />
      </div>
    </div>
  );
}
